import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { DateTime, SingleDayDateTime } from 'components/Date/DateUtil';
import { DetailsList } from 'components/DetailsList/DetailsList';
import { DetailsListItem } from 'components/DetailsList/Item/DetailsListItem';
import { DetailListSection } from 'components/DetailsList/Section/DetailListSection';
import { AREAS_OF_FOCUS } from 'utils/constants/general/areasOfFocus';

export const formatAmountString = (amount: string) => {
  const parts = amount.split('.');
  const cents = parseInt(parts[1], 10);
  const dollars = parts[0];
  return `$${dollars}${cents > 0 ? `.${cents}` : ''}`;
};

type Props = {
  areasOfFocus: ApiAreaOfFocus[];
  startDate: string | null;
  startTime: string | null;
  endDate: string | null;
  endTime: string | null;
  startsLocal: string | null;
  endsLocal: string | null;
  feeAmount: string | null;
  feeRequired: boolean;
  timezone: string | null;
  welcomeGroups: boolean;
  welcomeFamilies: boolean;
  detailsWheelchairAccessible: boolean;
};

export function EventDetailsList({
  areasOfFocus,
  startDate,
  startTime,
  endDate,
  endTime,
  startsLocal,
  endsLocal,
  feeAmount,
  feeRequired,
  timezone,
  welcomeGroups,
  welcomeFamilies,
  detailsWheelchairAccessible,
}: Props) {
  return (
    <DetailsList>
      {startDate &&
        endDate &&
        startsLocal &&
        endsLocal &&
        startDate === endDate && (
          <DetailsListItem
            title={getText('Date')}
            iconName="calendar"
            value={
              <SingleDayDateTime
                endsLocal={endsLocal}
                startsLocal={startsLocal}
                startTime={startTime}
                endTime={endTime}
                timezone={timezone}
              />
            }
          />
        )}

      {startDate && startsLocal && startDate !== endDate && (
        <DetailsListItem
          title={getText('Start Date')}
          iconName="hourglass"
          value={<DateTime datetime={startsLocal} timezone={timezone} />}
        />
      )}

      {endDate && endsLocal && endDate !== startDate && (
        <DetailsListItem
          title={getText('End Date')}
          iconName="hourglass"
          value={<DateTime datetime={endsLocal} timezone={timezone} />}
        />
      )}

      {feeRequired && (
        <DetailsListItem
          title={getText('Cost')}
          iconName="coin"
          value={`${getText(
            'Paid Event',
          )}${feeAmount ? `: ${formatAmountString(feeAmount)}` : ''}`}
        />
      )}

      {areasOfFocus?.length !== 0 && (
        <DetailsListItem
          iconName="globe"
          title={getText('Areas of Focus')}
          value={areasOfFocus.map((item) => AREAS_OF_FOCUS[item]).join(', ')}
        />
      )}

      <DetailListSection title={getText('Participation')}>
        {welcomeGroups && (
          <DetailsListItem iconName="group" value={getText('Groups Welcome')} />
        )}

        {welcomeFamilies && (
          <DetailsListItem
            iconName="family"
            value={getText('Families Welcome')}
          />
        )}

        {detailsWheelchairAccessible && (
          <DetailsListItem
            iconName="wheelchair"
            value={getText('Wheelchair Accessible')}
          />
        )}
      </DetailListSection>
    </DetailsList>
  );
}
